import Vue from 'vue'
import Quasar, {Ripple, CloseOverlay, Notify, Dialog, Screen, Cookies} from 'quasar-framework'

Vue.use(Quasar, {directives: [Ripple, CloseOverlay], plugins: [Notify, Dialog, Screen, Cookies]})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/quasar.js